"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.172 7.703a2.1 2.1 0 0 0-2.944 0 2.03 2.03 0 0 0 0 2.894 2.1 2.1 0 0 0 2.944 0 2.03 2.03 0 0 0 0-2.894m-3.929-.995a3.5 3.5 0 0 1 4.914 0 3.43 3.43 0 0 1 0 4.884 3.5 3.5 0 0 1-4.914 0 3.43 3.43 0 0 1 0-4.884M17.22 7.981a1.3 1.3 0 1 0-1.838 1.838 1.3 1.3 0 0 0 1.838-1.838l.483-.483zm-2.828-.99a2.7 2.7 0 0 1 3.818 0l-.495.495.495-.495a2.7 2.7 0 1 1-3.818 0m.209 6.288a.7.7 0 0 1 .7-.7h3a2.7 2.7 0 0 1 2.7 2.7v.5a.7.7 0 1 1-1.4 0v-.5a1.3 1.3 0 0 0-1.3-1.3h-3a.7.7 0 0 1-.7-.7M5.922 15c-.847 0-1.522.678-1.522 1.5v1.1a.7.7 0 1 1-1.4 0v-1.1c0-1.608 1.315-2.9 2.922-2.9h5.556c1.607 0 2.922 1.292 2.922 2.9v1.1a.7.7 0 1 1-1.4 0v-1.1c0-.822-.675-1.5-1.522-1.5z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CollaborateIcon24.js.map